export default __webpack_public_path__ + "static/media/disconnect-svgrepo-com.bd187649.svg";